import React, { useState, useContext, useEffect } from "react";
import { InfluencerProfileFirstSectionContainer } from "./InfluencerProfileFirstSectionStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import gift from './../../utils/images/gift.svg';
import avatar from './../../utils/images/avatar_fluincr.png';
import ModalPrices from "../ModalPrices/ModalPrices";
import ModalCreateCollaboration from "../ModalCreateCollaboration/ModalCreateCollaboration";
import { UserContext } from "../../context/userContext";
import { formatNumber, lowerFare2 } from "../../services/generalSevices";
import { CurrencyContext } from "../../context/currencyContext";
import { getConvertCurrency } from "../../api/exchangeApi";
import { getCollaboratorsByInfluencer } from "../../api/collaborationApi";

export default function InfluencerProfileFirstSection({ prices, isFavorite, setIsFavorite, collaborators, influencerId }) {

    const [showCreateCollaboration, setShowCreateCollaboration] = useState(false);
    const { currency } = useContext(CurrencyContext);
    const [price, setPrice] = useState(null);
    const [collaboratorsImages, setCollaboratorsImages] = useState([]);

    useEffect(() => {
        const amount = lowerFare2(prices);
        const auxCurrency = currency.symbol

        getConvertCurrency({ amount: amount }).then((response) => {
            //setPrice(response[auxCurrency].toFixed(0))
            setPrice(response[auxCurrency].toFixed(2))
        })
    }, [currency, prices])

    useEffect(() => {
        if (influencerId !== null) {
            getCollaboratorsByInfluencer({ influencerId: influencerId }).then((response) => {
                const auxCollaborators = response;
                const auxImages = [];
                auxCollaborators.map((collaborator) => {
                    if (collaborators.includes(collaborator.companyid)) {
                        auxImages.push(collaborator.imagecompany);
                    }
                })
                setCollaboratorsImages(auxImages);
            })
        }
    }, [influencerId])

    const emptyCollaborator = () => {
        const col = []
        for (let i = 0; i < (4 - collaboratorsImages.length); i++) {
            col.push(<div className="collaboration" key={`empty${i}`}></div>)
        }
        return (col);
    }

    return (
        <InfluencerProfileFirstSectionContainer>

            <div className="collaborationsContainer">
                <div className="collaborations">

                    {collaboratorsImages.map((image, index) => {
                        return (
                            <div className="collaboration" key={index}>
                                <img src={(image !== null) ? image : avatar} alt="collaborator" />
                            </div>
                        )
                    })}
                    {/* {emptyCollaborator()} */}

                </div>
                <p className="collaborationText"><FormattedMessage id="my_profile_first_section_text_6" defaultMessage="Colaboradores" /></p>
            </div>
            <div className="rateContainer">
                <div className="rate">
                    <p className="rateTitle"><FormattedMessage id="my_profile_first_section_text_2" defaultMessage="Foto / Video" /></p>
                    <div className="rateInformation">
                        <p className="rateDescription"><FormattedMessage id="my_profile_first_section_text_5" defaultMessage="Desde" /></p>
                        <div>
                            <p className="value">{currency.symbol} {formatNumber(price)} /  </p>
                            <img src={gift} alt="gift" />
                        </div>
                    </div>
                </div>

                <button className="startCollaboration" onClick={() => { setShowCreateCollaboration(true) }}><FormattedMessage id="my_profile_first_section_text_7" defaultMessage="Iniciar colaboración" /></button>

            </div>

            {(showCreateCollaboration) && (<ModalCreateCollaboration setShowCreateCollaboration={setShowCreateCollaboration} isFavorite={isFavorite} setIsFavorite={setIsFavorite} />)}

        </InfluencerProfileFirstSectionContainer>
    )
}